import React, { useState } from "react";
import axios from 'axios';
import './NewClientForm.css';

const NewClientForm = ({ mode = 'create', clientId = null, leadData = null, onClientCreated, onCancel, currentUserFullName }) => {
    const [formData, setFormData] = useState({
        client_name: leadData?.lead_name || '',
        client_email: leadData?.lead_email || '',
        client_phone: leadData?.lead_phone || '',
        client_address: leadData?.lead_address || '',
        client_city: leadData?.city || '',
        client_state: leadData?.state || '',
        client_country: leadData?.country || '',
        primary_contact: 'Super Admin',
        stock: '0',
        due_amount: '0.00',
        received_amount: '0.00',
        expense: '0.00',
        wallet_amount: '0.00',
        group_name: leadData?.group_name || '',
        sale_person: currentUserFullName || 'Super Admin',
        lead_id: leadData?.id || 0,
        mode: mode
    });

    const [saving, setSaving] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.client_name || !formData.client_phone) {
            alert("Client Name and Phone are required.");
            return;
        }
        setSaving(true);
        try {
            const token = localStorage.getItem("token");
            const payload = { ...formData };
            if (mode === 'edit') payload.id = clientId;

            await axios.post('https://skcapi.btcjapan.co/create_update_client.php', payload, {
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
            });

            alert(mode === 'edit' ? 'Client updated successfully!' : 'Client created successfully!');
            if (onClientCreated) onClientCreated();
        } catch (err) {
            console.error(err);
            alert("Error saving client.");
        } finally { setSaving(false); }
    };

    return (
        <form className="new-client-form" onSubmit={handleSubmit}>
            <div className="form-row-2col">
                <div className="form-group"><label>Client Name <span className="required">*</span></label><input type="text" name="client_name" value={formData.client_name} onChange={handleChange} /></div>
                <div className="form-group"><label>Client Phone <span className="required">*</span></label><input type="text" name="client_phone" value={formData.client_phone} onChange={handleChange} /></div>
                <div className="form-group"><label>Client Email</label><input type="email" name="client_email" value={formData.client_email} onChange={handleChange} /></div>
                <div className="form-group"><label>Primary Contact</label><input type="text" name="primary_contact" value={formData.primary_contact} onChange={handleChange} /></div>
                <div className="form-group"><label>Stock</label><input type="text" name="stock" value={formData.stock} onChange={handleChange} /></div>
                <div className="form-group"><label>Due Amount</label><input type="number" step="0.01" name="due_amount" value={formData.due_amount} onChange={handleChange} /></div>
                <div className="form-group"><label>Received Amount</label><input type="number" step="0.01" name="received_amount" value={formData.received_amount} onChange={handleChange} /></div>
                <div className="form-group"><label>Expense</label><input type="number" step="0.01" name="expense" value={formData.expense} onChange={handleChange} /></div>
                <div className="form-group"><label>Wallet Amount</label><input type="number" step="0.01" name="wallet_amount" value={formData.wallet_amount} onChange={handleChange} /></div>
                <div className="form-group"><label>Group Name</label><input type="text" name="group_name" value={formData.group_name} onChange={handleChange} /></div>
                <div className="form-group"><label>Sale Person</label><input type="text" name="sale_person" value={formData.sale_person} onChange={handleChange} /></div>
                <div className="form-group"><label>Client Address</label><textarea rows="1" name="client_address" value={formData.client_address} onChange={handleChange}></textarea></div>
                <div className="form-group"><label>City</label><input type="text" name="client_city" value={formData.client_city} onChange={handleChange} /></div>
                <div className="form-group"><label>State</label><input type="text" name="client_state" value={formData.client_state} onChange={handleChange} /></div>
                <div className="form-group"><label>Country</label><input type="text" name="client_country" value={formData.client_country} onChange={handleChange} /></div>
            </div>

            <div style={{marginTop:'20px', textAlign:'right'}}>
                {mode === 'edit' && <button type="button" onClick={onCancel} style={{marginRight:'10px', padding:'8px 20px', border:'1px solid #ccc', borderRadius:'4px', cursor:'pointer'}}>Cancel</button>}
                <button type="submit" className="save-btn-blue" disabled={saving}>{saving ? 'Saving...' : (mode === 'edit' ? 'Update Client' : 'Save Client')}</button>
            </div>
        </form>
    );
};

export default NewClientForm;